(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').factory('mx.SolutionBuilderAgent.ConditionsBuilder.Builder', ClassFactory);
	ClassFactory.$inject = ['mx.SolutionBuilderAgent.ConditionsBuilder.Group'];

	function ClassFactory(ConditionsBuilderGroup) {
		function ConditionsBuilder(config) {
			ConditionsBuilderGroup.call(this, {}, config);

			this.initialized = false;

			var properties = [],
				attributes = [],
				filteredProperties = [],
				predefinedConditions = config.predefinedConditions,
				trigger = config.trigger;

			Object.defineProperty(this, 'trigger', {
				enumerable: true,
				get: function () {
					return trigger;
				},
			});

			Object.defineProperty(this, 'attributes', {
				enumerable: true,
				get: function () {
					return attributes;
				},
			});

			Object.defineProperty(this, 'filteredProperties', {
				enumerable: false,
				get: function () {
					return filteredProperties;
				},
				set: function (newFilteredProperties) {
					filteredProperties = newFilteredProperties;
				},
			});

			Object.defineProperty(this, 'properties', {
				enumerable: true,
				set: function (newProperties) {
					if (Array.isArray(newProperties)) {
						properties = newProperties;
						filteredProperties = newProperties;
					} else {
						properties = [];
						filteredProperties = [];
					}

					attributes = properties.filter(function (property) {
						return property.IsAttribute;
					});

					if (predefinedConditions) {
						if (Array.isArray(predefinedConditions.Groups)) {
							predefinedConditions.Groups.forEach(function (g) {
								this.addGroup(g);
							}, this);
						}

						if (Array.isArray(predefinedConditions.Conditions)) {
							predefinedConditions.Conditions.forEach(function (c) {
								this.addCondition(c);
							}, this);
						}
						predefinedConditions = null;
					}

					this.initialized = true;
					this.updateOutput();
				},
				get: function () {
					return properties;
				},
			});
		}

		ConditionsBuilder.prototype = Object.create(ConditionsBuilderGroup.prototype);
		ConditionsBuilder.prototype.constructor = ConditionsBuilder;

		ConditionsBuilder.prototype.setFilterForProperties = function (searchText) {
			const properties = this.properties || [];
			if (searchText) {
				searchText = searchText.toLowerCase();
				this.filteredProperties = properties.filter((property) => property.Title && property.Title.toLowerCase().indexOf(searchText) !== -1);
			} else {
				this.filteredProperties = properties;
			}
		};

		ConditionsBuilder.prototype.updateOutput = function () {
			if (!this.initialized) {
				return;
			}
			if (typeof this._builderConfig.builderOutput === 'function') {
				this.output = this._builderConfig.builderOutput(this);
			}
			if (typeof this.onOutputChange === 'function') {
				this.onOutputChange(this.output);
			}
		};

		return ConditionsBuilder;
	}
})();
